import { Button } from '@bbl-digital/snorre'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { addMessageRecipients } from 'shared/store/sendMessage/message'
import {
  handleRecipientModal,
  handleSubmitEmailRecipients,
  handleSubmitSmsRecipients,
  onRecipientsClose,
} from 'shared/store/sendMessage/recipients'
import {
  getListedRecipients,
  getMessageRecipients,
  getRecipientOpenState,
} from 'shared/store/sendMessage/recipients/selectors'
import { useAppDispatch } from 'shared/store/store'
import { Wrapper } from './styles'
import TransformToBccModal from './TransformToBccModal'

const RecipientsListActions: FC = () => {
  const dispatch = useAppDispatch()
  const openState = useSelector(getRecipientOpenState)
  const { openStateType } = useSelector(getMessageRecipients)
  const amountOfRecipientsAdded = useSelector(getListedRecipients).length
  const [showBccTransformModal, setShowBccTransformModal] = useState(false)

  const onClose = () => {
    dispatch(handleRecipientModal({ open: null, type: null }))
    dispatch(onRecipientsClose())
  }

  const onSubmit = (transformToBcc?: boolean) => {
    // If the user sends to more than 5 recipients in an email,
    // we ask they wanna add them as blind carbon copy (blindkopi) instead
    if (
      openState === 'Email' &&
      openStateType === RecipientTypeEnum.To &&
      amountOfRecipientsAdded > 5 &&
      !showBccTransformModal
    ) {
      setShowBccTransformModal(true)
      return
    }

    if (openState === 'SMS') dispatch(handleSubmitSmsRecipients())
    else if (openState === 'Email')
      dispatch(
        handleSubmitEmailRecipients({
          overrideRecipientType: transformToBcc
            ? RecipientTypeEnum.Bcc
            : undefined,
        })
      )
    dispatch(addMessageRecipients())
  }

  return (
    <>
      <Wrapper>
        <Button outline onClick={onClose}>
          Avbryt
        </Button>
        <Button onClick={() => onSubmit()}>
          Legg til{' '}
          {Boolean(amountOfRecipientsAdded)
            ? `(${amountOfRecipientsAdded})`
            : ''}
        </Button>
      </Wrapper>

      {showBccTransformModal && (
        <TransformToBccModal
          onClose={() => setShowBccTransformModal(false)}
          onDecision={(decision) => onSubmit(decision === 'yes')}
        />
      )}
    </>
  )
}

export default RecipientsListActions
